<style lang="scss" scoped="">
.el-row {
  margin-bottom: 10px;
}

.org-info {
  background: #fff;
  margin-bottom: 20px;
}

.base-pic-list {
  display: flex;
  flex-wrap: wrap;

  .base-pic-item {
    border: 1px solid #eee;
    position: relative;
    cursor: pointer;
    width: 180px;
    margin: 5px;
    padding: 10px;
    font-size: 12px;

    img {
      width: 180px;
      height: 180px;
      display: block;
      background: #ccc;

    }

  }
}

.batch-upload-form {
  padding-top: 20px;
  padding-right: 80px
}

</style>
<template>
  <div class="org-info">
    <!--    <div class="opera-icon">-->
    <!--      <des-btn icon="back" perm="show" @click="$router.push('/retrospect/business/import/id')">返回</des-btn>-->
    <!--    </div>-->
    <form-show-part :pageSetsItem="pageSets[0]" :currentTab="{}">
      <template slot="content">
        <el-form ref="form" style="margin-top: -20px"
                 label-width="100px" class="batch-upload-form">
          <el-form-item>
            <oms-upload-relation uploadUrl="/qingstor/code/pre" deleteUrl="/code-upload/file"
                                 :fileList="fileList" :formData="{objectType:'traceCodeByOrg',
                                   type: '2'}" uploadTip="请批量选取业务数据XML文件"
                                 accept="xml" @isProgress="onUploadProgress"
                                 :showFileList="false"
                                 :clearUploadFiles="clearUploadFiles"
                                 @refreshCodes="setIsUploading"></oms-upload-relation>
            <el-tag class="mt-10" v-show="uploading" type="warning">正在上传文件, 请勿关闭窗口</el-tag>
          </el-form-item>
        </el-form>
      </template>
    </form-show-part>
    <form-show-part :pageSetsItem="pageSets[1]" :currentTab="{}">
      <template slot="content">
        <div style="padding: 20px;margin-top: -20px" v-show="dataList.length>0">
          <h4><i class="el-icon-success" style="color: limegreen"></i> 上传成功记录</h4>
          <el-table :data="dataList" border
                    class="header-list store border-black record-table" style="width: 100%">
            <el-table-column
              align="center"
              label="文件名称"
              min-width="20%" prop="sourceOrgId">
              <template slot-scope="scope">
                {{ scope.row.fileName }}
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              label="订单编号"
              min-width="15%" prop="orderNo">
              <template slot-scope="scope">
                {{ scope.row.orderNo }}
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              label="货主"
              min-width="25%" prop="sourceOrgId">
              <template slot-scope="scope">
                <el-select v-model="scope.row.sourceOrgId" :clearable="true"
                           :remote-method="(query)=>queryAllFactory(query,scope.row)" filterable
                           placeholder="请输入名称搜索货主信息"
                           popperClass="good-selects" @change="setSourceOrgId(scope.row)"
                           remote @click.native.once="(query)=>queryAllFactory('',scope.row)">
                  <el-option v-for="org in scope.row.allOrgList" :key="org.id" :label="org.name" :value="org.id">
                    <slot :row="org">
                      <div style="overflow: hidden">
                        <span class="pull-left" style="clear: right">{{ org.name }}</span>
                      </div>
                    </slot>
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              label="往来单位" min-width="25%" prop="businessOrgId">
              <template slot-scope="scope">
                <el-select v-model="scope.row.businessOrgId" :clearable="true"
                           :remote-method="(query)=>queryBizOrgList(query,scope.row)" filterable
                           placeholder="请输入名称搜索往来单位"
                           popperClass="good-selects"
                           remote @click.native.once="(query)=>queryBizOrgList('',scope.row)"
                           @change="setBusinessOrgId(scope.row)">
                  <el-option v-for="org in scope.row.bizOrgList" :key="org.id" :label="org.name" :value="org.id">
                    <slot :row="org">
                      <div style="overflow: hidden">
                        <span class="pull-left" style="clear: right">{{ org.name }}</span>
                      </div>
                    </slot>
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              label="物流方式" min-width="15%" prop="transportationMode">∂ç
              <template slot-scope="scope">
                <el-select type="text" v-model="scope.row.transportationMode"
                           placeholder="请选择物流方式" clearable>
                  <el-option :value="item.label" :key="item.key" :label="item.label"
                             v-for="item in transportationMeansList"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              label="运输条件" min-width="15%" prop="transportationMode">
              <template slot-scope="scope">
                <el-select type="text" v-model="scope.row.logisticsCondition" placeholder="请选择运输条件" clearable>
                  <el-option :value="item.label" :key="item.key" :label="item.label"
                             v-for="item in transportationConditionList"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              label="操作单位" min-width="25%" prop="operateOrgId">
              <template slot-scope="scope">
                <el-select v-model="scope.row.operateOrgId" :clearable="true"
                           :remote-method="(query)=>queryCallAllFactory(query,scope.row)" filterable
                           placeholder="请输入名称搜索货主信息"
                           popperClass="good-selects"
                           remote @click.native.once="(query)=>queryCallAllFactory('',scope.row)">
                  <el-option v-for="org in scope.row.callOrgList" :key="org.id" :label="org.name" :value="org.id">
                    <slot :row="org">
                      <div style="overflow: hidden">
                        <span class="pull-left" style="clear: right">{{ org.name }}</span>
                      </div>
                    </slot>
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              min-width="20%"
              align="center"
              fixed="right"
              label="操作"
              width="40">
              <template slot-scope="scope">
                <el-button size="small" style="padding: 0;margin: 0" type="text"
                           @click="eddTable(scope)">删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-row style="text-align: center;padding:10px 0">
            <el-button v-show="this.dataList.length>0" :loading="doing" type="success" @click="onSubmit">保存</el-button>
          </el-row>
        </div>
        <div style="padding: 20px;margin-top: -20px" v-show="errorList.length>0">
          <h4><i class="el-icon-error" style="color: red"></i> 失败上传记录</h4>
          <el-table :data="errorList" :header-row-class-name="'headerClass'" ref="orderDetail">
            <el-table-column label="序号" min-width="20" prop="index">
            </el-table-column>
            <el-table-column label="文件名称" min-width="150" prop="name">
            </el-table-column>
            <el-table-column label="失败原因" min-width="150" prop="message">
            </el-table-column>
          </el-table>
        </div>
      </template>
    </form-show-part>
  </div>
</template>
<script>
import {BaseInfo, businessOrg, http} from '@/resources';
import methodsMixin from '@/mixins/methodsMixin';

export default {
  components: {},
  mixins: [methodsMixin],
  data: function () {
    return {
      showFlag: false,
      dataList: [],
      fileList: [],
      doing: false,
      isUploading: false,
      isChecked: false,
      uploadingFiles: [],
      rules: {},
      successList: [],
      errorList: [],
      attachmentFile: []
    };
  },
  computed: {
    transportationConditionList: function () {
      return this.$getDict('transportationCondition');
    },
    uploading() {
      if (!this.uploadingFiles) {
        return false;
      }
      return this.uploadingFiles.some(val => val.isUploading);
    },
    pageSets() {
      let ary = [
        {name: '批量上传业务数据XML', key: 0}
      ];
      if (this.errorList.length > 0 || this.dataList.length > 0) {
        ary.push({name: '已上传的XML', key: 1});
      }
      return ary;
    },
    transportationMeansList: function () {
      let a = this.$getDict('outTransportMeans');
      if (a) {
        a = JSON.parse(JSON.stringify(a));
      }
      a && a.forEach(i => {
        i.key = i.key + '1_';
      });
      let b = this.$getDict('transportationMeans');
      if (b) {
        b = JSON.parse(JSON.stringify(b));
      }
      b && b.forEach(i => {
        i.key = i.key + '2_';
      });
      let ary = [];
      if (a && b) {
        ary = a.concat(b);
      }
      return ary;
    }
  },
  mounted() {
    this.resetForm();
    this.successList = [];
    this.errorList = [];
    this.attachmentFile = [];
  },
  watch: {},
  methods: {
    setSourceOrgId(item) {
      if (!item) {
        return;
      }
      item.allOrgList.forEach(v => {
        if (v.id === item.sourceOrgId) {
          item.sourceOrgId = v.id;
          item.sourceOrgName = v.name;
        }
      })
    },
    setBusinessOrgId(item) {
      if (!item) {
        return;
      }
      item.bizOrgList.forEach(v => {
        if (v.id === item.businessOrgId) {
          item.directOrgId = v.id;
          item.directOrgName = v.name;
        }
      })
    },
    queryAllFactory(query, row) { // 查询所有单位
      let params = {
        keyWord: query
      };
      BaseInfo.query(params).then(res => {
        row.allOrgList = res.data.list;
      });
    },
    queryBizOrgList(query, row) {
      let params = {};
      if (typeof query === 'string') {
        params = {keyWord: query, deleteFlag: false, orgId: this.$store.state.user.userCompanyAddress}
      } else if (typeof query === 'object') {
        params = query;
      }
      businessOrg.query(params).then(res => {
        row.bizOrgList = res.data.list.map(m => ({
          id: m.id,
          businessOrgId: m.businessOrgId,
          name: m.businessOrgName,
          manufacturerCode: m.businessOrgManufacturerCode,
          creditCode: m.businessOrgCreditCode
        }));
      });
    },
    queryCallAllFactory(query, row) { // 查询DHS回调单位
      let params = {
        keyWord: query
      };
      BaseInfo.query(params).then(res => {
        row.callOrgList = res.data.list;
      });
    },
    setDirectOrgId(val) {
      if (!val) return;
      let list = this.bizOrgList.filter(v => v.id === val);
      if (list && list[0]) {
        val.directOrgId = list[0].businessOrgId;
        val.directOrgName = list[0].name;
      }
    },
    eddTable(scope) {
      this.dataList.splice(scope.$index, 1);
    },
    resetForm() {
      this.fileList = [];
      this.isUploading = false;
      this.uploadingFiles = [];
      this.isChecked = false;
    },
    setIsUploading(file) {
      if (!file) return;
      this.attachmentFile.push(file);
      this.uploadingFiles.forEach(val => {
        if (file.uid === val.uid) {
          val.isUploading = false;
        }
      })
      let newFile = Object.assign({}, file, {message: file.response.message});
      if (file.response.state === 'FAIL') {
        this.errorList.push(Object.assign({}, newFile, {index: this.errorList.length + 1}));
        return;
      }
      this.analysis(file);
    },
    onUploadProgress(file) {
      let containFlag = this.uploadingFiles.some(value => value.uid === file.uid);
      if (!containFlag) {
        let newFile = Object.assign({}, file, {isUploading: true});
        this.uploadingFiles.push(newFile);
      }
    },
    analysis(file) {
      let attachment = Object.assign({}, file);
      if (!attachment) {
        return this.$notify.info({message: '请上传文件'});
      }
      // 设置货主和操作单位
      let org = JSON.parse(window.localStorage.getItem('org'));
      let tempOrg = {
        id: org.id,
        name: org.name
      }
      /*// 删除相同文件名称数据
      let index = null;
      for (let i = 0; i < this.dataList.length; i++) {
        let data = this.dataList[i];
        if (data.fileName === file.name) {
          index = i;
          break;
        }
      }
      if (index) {
        this.dataList.splice(index, 1);
      }*/
      let data = Object.assign({}, {
        fileName: file.name,
        fileId: attachment.response.attachmentId,
        sourceOrgId: org.id,
        sourceOrgName: org.name,
        operateOrgId: org.id,
        callOrgList: [tempOrg],
        allOrgList: [tempOrg],
        bizOrgList: [],
        directOrgName: '',
        businessOrgId: '',
        directOrgId: ''
      });
      this.analysisDoing = true;
      http.post('/code-biz/ali-file/parse-org', {fileId: attachment.response.attachmentId}).then(res => {
        this.analysisDoing = false;
        this.analysisComplete = true;
        data.directOrgName = res.data.name;
        data.businessOrgId = res.data.id;
        data.directOrgId = res.data.id;
        data.orderNo = res.data.orderNo;
        this.dataList.push(data);
        if (res.data.id) {
          data.bizOrgList = [
            {id: res.data.id, name: res.data.name}
          ];
        }
      }).catch(e => {
        /*this.$notify.error({
          duration: 2000,
          message: e.response && e.response.data && e.response.data.msg || '解析失败'
        });*/
        this.errorList.push(Object.assign({}, {
          name: file.name,
          message: e.response && e.response.data && e.response.data.msg
        }, {index: this.errorList.length + 1}));
        this.analysisDoing = false;
      });
    },
    clearUploadFiles(files) {
      this.uploadingFiles = [];
    },
    onSubmit() {
      if (this.doing) {
        return false;
      }
      if (!this.dataList.length) {
        this.$notify.info({
          message: '上传数据不能为空'
        });
        return;
      }
      this.doing = true;
      http.post('/code-biz/ali-file/batch-add', this.dataList).then(res => {
        this.doing = false;
        this.$notify.success({
          message: '解析文件成功'
        });
        this.$router.push("/retrospect/business/import/id");
      }).catch(e => {
        const h = this.$createElement;
        this.$notify.error({
          duration: 4500,
          message: h('i', {style: 'word-break: break-all'}, e.response && e.response.data && e.response.data.msg || '解析失败')
        });
        this.doing = false;
      });
    }
  }
};
</script>
